module.exports = __webpack_public_path__ + "static/bonifico2-d0de1d9ef186080db3bc794bd2afb482.png";